import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/common/LanguageSwitcher';
import { BRAND } from '../../theme/brandTokens';
import { brandBackdropSx, brandCardSx } from '../../theme/brandSurfaces';

const StoreNotFoundPage = () => {
  const { t } = useTranslation();
  const title = t('notFound.storeTitle');
  const message = t('notFound.storeMessage');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...brandBackdropSx,
        p: 3,
        position: 'relative',
      }}
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={message} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={message} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={message} />
      </Helmet>
      <Box sx={{ position: 'absolute', top: 24, right: 24, zIndex: 1100 }}>
        <LanguageSwitcher sx={{ mb: 0 }} />
      </Box>
      <Paper
        sx={{
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          maxWidth: 520,
          width: '100%',
          ...brandCardSx,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            mx: 'auto',
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: BRAND.accent,
            color: BRAND.onAccent,
          }}
        >
          <LinkOffIcon sx={{ fontSize: 36 }} />
        </Box>
        <Typography variant="h1" component="p" sx={{ fontSize: '4.5rem', fontWeight: 800, color: BRAND.accentText, mb: 1, lineHeight: 1 }}>
          404
        </Typography>
        <Typography variant="h5" component="h1" sx={{ mb: 2, fontWeight: 700, color: BRAND.text }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1.5 }}>
          {message}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('notFound.storeContact')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default StoreNotFoundPage;
